<ptl-v3-filter-shell [title]="'translations.filter.attendance.name' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <ptl-select
    shell-controls
    class="v3-attendance-filter__is-select"
    [options]="isOptions"
    [ngModel]="attendanceIs"
    (selectionChange)="onAttendanceIsChange($event)"
  ></ptl-select>
  <div class="v3-attendance-filter__list">
    @for (attendance of attendances; track attendance.type) {
      <ptl-sg-checkbox
        class="v3-attendance-filter__item"
        [checked]="attendance.value"
        [ariaLabel]="
          attendance.value
            ? ('translations.global.ariaLabels.uncheckAttendanceFilter' | transloco: { attendanceName: attendance.label })
            : ('translations.global.ariaLabels.checkAttendanceFilter' | transloco: { attendanceName: attendance.label })
        "
        (checkboxChange)="changeAttendance(attendance.type)"
      >
        <span class="v3-attendance-filter__label">{{ attendance.label }}</span>
      </ptl-sg-checkbox>
    }
  </div>
</ptl-v3-filter-shell>
